import script from "./NotesCellElementLite.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotesCellElementLite.vue?vue&type=script&setup=true&lang=ts"

import "./NotesCellElementLite.vue?vue&type=style&index=0&id=239d47b0&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-239d47b0"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
